import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { EnvironmentService } from '../../../../../../common/services/env-configuration/environment.service';
import { ImageUtils } from '../../../../../../common/utils/image-utils';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-form-field-image',
  templateUrl: './image-form-field.component.html',
  styleUrls: ['./image-form-field.component.scss'],
  standalone: false,
})
export class ImageFormFieldComponent extends DataTypeComponent implements OnDestroy, AfterViewInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: string;

  @Input() editMode: boolean;

  imageSrc: string;
  imageInputChange = new Subject<void>();

  constructor(
    private environmentService: EnvironmentService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterViewInit() {
    if (this.data !== undefined) {
      if (typeof this.data === 'string' && this.data.indexOf('./assets/') >= 0) {
        this.imageSrc = ImageUtils.relocateImage(this.data);
        this.changeDetectorRef.detectChanges();
      } else if (typeof this.data === 'string' && this.data.startsWith('http')) {
        this.imageSrc = this.data;
        this.changeDetectorRef.detectChanges();
      }
    }
    this.imageInputChange.pipe(debounceTime(200)).subscribe(() => {
      const imageSrc = this.formGroup.get(this.fieldConfig.name).value;
      if (this.fieldConfig.requiresKicktheDirectory) {
        if (new RegExp('^http[s]?:\\/\\/storage\\.googleapis\\.com\\/kickthe', 'i').test(imageSrc)) {
          const start = imageSrc.indexOf('kickthe') + 7;
          this.formGroup.get(this.fieldConfig.name).setValue(imageSrc.substring(start));
        } else if (imageSrc.startsWith('http')) {
          this.formGroup.get(this.fieldConfig.name).setErrors({ requiresKicktheDirectory: true });
        }
      }
      this.imageSrc = ImageUtils.relocateImage(imageSrc);
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {}

  public clearField() {
    this.formGroup.get(this.fieldConfig.name).setValue('');
    this.imageSrc = undefined;
  }

  refreshImage(): void {
    this.imageInputChange.next();
  }
}
